import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	firebaseReady: false,
	firebaseTokenEnabled: false,
	firebaseToken: null,
};

export const firebaseSlice = createSlice({
	name: 'firebase',
	initialState,
	reducers: {
		setFirebaseReady: (state, action) => {
			state.firebaseReady = action.payload;
		},
		setFirebaseTokenEnabled: (state, action) => {
			state.firebaseTokenEnabled = action.payload;
		},
		setFirebaseToken: (state, action) => {
			state.firebaseToken = action.payload;
		},
		clearFirebaseToken: (state) => {
			state.firebaseToken = null;
		},
		resetFirebase: (state) => {
			state.firebaseReady = false;
			state.firebaseTokenEnabled = false;
			state.firebaseToken = null;
		},
	},
});

export const {
	setFirebaseReady,
	resetFirebase,
	setFirebaseTokenEnabled,
	setFirebaseToken,
	clearFirebaseToken,
} = firebaseSlice.actions;
export default firebaseSlice.reducer;
